var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Checks if every entry in subset exists in the items array
 *
 * @template T
 * @param {T[]} items The array of items
 * @param {T[]} subset The values that we check for existence in items
 *
 * @returns {boolean} Whether or not all items in subset exist in items
 */
export var includesAll = function (items, subset) { return items.length >= subset.length &&
    Array.from(new Set(__spread(items, subset))).length === items.length; };
//# sourceMappingURL=includesAll.js.map